import { InteractionType } from "@azure/msal-browser";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  MsalProvider,
  UnauthenticatedTemplate,
  MsalAuthenticationTemplate,
} from "@azure/msal-react";
import ProtectedRoutes from "./Generic/ProtectedRoutes";
import LandingPage from "./Components/LandingPage";
import Authenticating from "./Generic/Authenticating";
import UserContext from "./UserContext";
import Navigation from "./Components/Navigation";
import ResultsHistory from "./Components/ResultsHistory";

function App({ msalInstance }) {
  return (
    <BrowserRouter>
      <MsalProvider instance={msalInstance}>
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          <UserContext.Provider
            value={msalInstance?.getActiveAccount()?.idTokenClaims}
          >
            <Navigation />
            <ProtectedRoutes>
              <Routes>
                <Route path="/" element={<LandingPage />} />
                <Route path="/history" element={<ResultsHistory />} />
              </Routes>
            </ProtectedRoutes>
          </UserContext.Provider>
        </MsalAuthenticationTemplate>
        <UnauthenticatedTemplate>
          <Authenticating />
        </UnauthenticatedTemplate>
      </MsalProvider>
    </BrowserRouter>
  );
}

export default App;

//Trigger
